export const ASSET_CLOSURE_STEP = {
  USER: 0,
  REQUEST_STEP_1: 1, // นักวิชาการ
  APPROVE_STEP_1: 2, // ผอ สำนัก
  REQUEST_STEP_2: 3, // เจ้าหน้าที่พัสดุ
  APPROVE_STEP_2: 4, // ผอ อำนวยการ
}
